export const ClaimCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'B',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  HeaderRow: {
    flow: 'x',
    align: 'center flex-start',
    justifyContent: 'space-between',
    ClaimNumber: { text: (el, s) => s.claimNumber || '', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
    ClaimStatus: {
      tag: 'span',
      text: (el, s) => s.claimStatus || '',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => {
        const st = s.claimStatus
        if (st === 'Submitted') return 'blue.15'
        if (st === 'Accepted') return 'teal.15'
        if (st === 'Paid') return 'green.15'
        if (st === 'Denied') return 'red.15'
        if (st === 'Appealed') return 'amber.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const st = s.claimStatus
        if (st === 'Submitted') return 'blue'
        if (st === 'Accepted') return 'teal'
        if (st === 'Paid') return 'green'
        if (st === 'Denied') return 'red'
        if (st === 'Appealed') return 'amber'
        return 'inkMuted'
      }
    }
  },

  PatientName: { text: (el, s) => s.patientName || '', fontSize: 'Z', color: 'inkText', fontWeight: '600' },
  ProviderName: { text: (el, s) => s.providerName || '', fontSize: 'Y', color: 'inkMuted' },
  DateOfService: { text: (el, s) => s.dateOfService ? `DOS: ${s.dateOfService}` : '', fontSize: 'Y', color: 'inkMuted' },

  CDTCodes: {
    flow: 'x',
    gap: 'Y',
    flexWrap: 'wrap',
    children: (el, s) => (s.cdtCodes || []).map(code => ({ text: code })),
    childrenAs: 'state',
    childExtends: 'ClaimCDTCode'
  },

  Divider: { height: '1px', background: 'inkBorder' },

  FinancialsRow: {
    flow: 'y',
    gap: 'Y',
    TotalCharged: {
      flow: 'x',
      justifyContent: 'space-between',
      Label: { text: '{{ totalCharged | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.totalCharged || '', fontSize: 'Z', fontWeight: '700', color: 'inkText' }
    },
    InsurancePayment: {
      flow: 'x',
      justifyContent: 'space-between',
      Label: { text: '{{ insurancePayment | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.insurancePayment || '', fontSize: 'Z', fontWeight: '600', color: 'green' }
    },
    PatientResponsibility: {
      flow: 'x',
      justifyContent: 'space-between',
      Label: { text: '{{ patientResponsibility | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
      Value: { text: (el, s) => s.patientResponsibility || '', fontSize: 'Z', fontWeight: '600', color: 'inkText' }
    }
  }
}

export const ClaimCDTCode = {
  tag: 'span',
  text: (el, s) => s.text || '',
  fontSize: 'Y',
  fontWeight: '600',
  padding: 'X Y',
  round: 'Y',
  background: 'inkSurface',
  color: 'inkMuted'
}
